import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../index';
import { memoryFactsKeys } from './memoryFacts.keys';
import { getMemoryClusters, getMemoryFacts, deleteMemoryFact, rebuildMemories } from './memoryFacts.api';
const FACTS_PAGE_SIZE = 1000;
export const useMemoryClustersQuery = () => {
    return useQuery({
        queryKey: memoryFactsKeys.clusters(),
        queryFn: getMemoryClusters
    });
};
export const useMemoryFactsQuery = (clusterId) => {
    return useInfiniteQuery({
        queryKey: memoryFactsKeys.facts(clusterId),
        queryFn: ({ pageParam }) => getMemoryFacts({
            cluster_id: clusterId,
            cursor: pageParam,
            limit: FACTS_PAGE_SIZE
        }),
        initialPageParam: undefined,
        getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
        enabled: clusterId !== undefined
    });
};
export const useDeleteMemoryFactMutation = () => {
    return useMutation({
        mutationFn: deleteMemoryFact,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: memoryFactsKeys.all() }).then();
        }
    });
};
export const useRebuildMemoriesMutation = () => {
    return useMutation({
        mutationFn: rebuildMemories,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: memoryFactsKeys.all() }).then();
        }
    });
};
//# sourceMappingURL=memoryFacts.query.js.map